import { reducers } from 'redux/core'
import request from 'sb-request'


const addRequest = (body) => {
  reducers.view.requestPage.setFetchingStatus(true)

  return request.post('rest/product-request', { body })
    .finally(() => reducers.view.requestPage.setFetchingStatus(false))
}


export default {
  addRequest,
}
